<div [formGroup]='commonFields'>
  <div class="form-group format d-flex">
    <div class="col-sm validate"> 
      <div>
        <input type="checkbox" formControlName="validateRequest"> Validate Request
      </div>
      <div>
        <input type="checkbox" formControlName="validateResponse"> <span> Validate Response</span>
      </div>
      
    </div>
  </div>
  <div class="clearfix"></div>
  <div class="form-group format response">
    <span class="responseFormat">Response Format:</span><span class="format"><input type="radio" name="response"
        formControlName="response" value="XML" /> XML</span>
    <span class="format"> <input type="radio" name="response" formControlName='response' value='HTML' /> HTML </span>
  </div>
  <div class="col-md-4">
    <div class="form-group format">
      <label for="userId">User Id</label>
      <input type="text" tabindex="1" formControlName="userId" class="form-control" id="userId">
    </div>
    <div class="form-group">
      <label for="exampleSelect">Server</label>
      <select tabindex="3" id="server" name="server" formControlName="server" class="form-control"
        (change)="selectServerValue($event);">
        <option value="SecureDataIntegrationToolkit" [selected]="true">Secure Data Integration Toolkit</option>
        <option value="Other">Other</option>
      </select>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group format">
      <label for="password">Password</label>
      <input  tabindex="2" type="password" formControlName="password" class="form-control" id="password" autocomplete="on">
    </div>
  </div>
  <div class="clearfix"></div>
  <div class="col-md-4" *ngIf="selectedServerValue=='Other'">
    <div class="form-group">
      <label class="col-lg-1 col-form-label form-control-label">Url</label>
      <input class="form-control" formControlName="url" type="text">
    </div>
  </div>
  <div class="clearfix"></div>
</div>
